import request from '@/utils/request'


// 查询积分提现活动信息列表
export function listActivity(query) {
  return request({
    url: '/withdrawal/activity/list',
    method: 'get',
    params: query
  })
}

// 查询积分提现活动信息分页
export function pageActivity(query) {
  return request({
    url: '/withdrawal/activity/page',
    method: 'get',
    params: query
  })
}

// 查询积分提现活动信息详细
export function getActivity(data) {
  return request({
    url: '/withdrawal/activity/detail',
    method: 'get',
    params: data
  })
}

// 新增积分提现活动信息
export function addActivity(data) {
  return request({
    url: '/withdrawal/activity/add',
    method: 'post',
    data: data
  })
}

// 修改积分提现活动信息
export function updateActivity(data) {
  return request({
    url: '/withdrawal/activity/edit',
    method: 'post',
    data: data
  })
}

// 删除积分提现活动信息
export function delActivity(data) {
  return request({
    url: '/withdrawal/activity/delete',
    method: 'post',
    data: data
  })
}
